module.exports = __webpack_public_path__ + "static/media/plico2.5dbafbe4.jpg";